<template>
    <div>
        <template v-if="showCouponPriceCard">
            <div class="benefit-price-card">
                <div class="benefit-price-main">
                    <div class="benefit-price-head">
                        <span class="benefit-price-tag">惠后约</span>
                        <span class="benefit-price-desc">叠加优惠后的预计到手单价</span>
                    </div>
                    <div class="benefit-price-row">
                        <em class="benefit-yuan">¥</em>
                        <span class="benefit-price">{{ typeof goodsSkuDetail.coupon_price == 'string'?goodsSkuDetail.coupon_price:goodsSkuDetail.coupon_price.join('~')  }}</span>
                        <span class="benefit-unit" v-if="unitText">/{{ unitText }}</span>
                    </div>
                    <div class="benefit-origin-row">
                        <span class="benefit-origin-label">销售价</span>
                        <span class="benefit-origin-price">¥{{ currentSalePrice }}<template v-if="unitText">/{{ unitText }}</template></span>
                    </div>
                </div>
                <div class="benefit-save-tag" v-if="savingText">{{ savingText }}</div>
            </div>
        </template>
        <template v-else>
            <dl class="item-line">
                <dt class="ns-text-color-gray titl-name">销售价</dt>
                <dd>
                    <em class="yuan ns-text-color">¥</em>
                    <template v-if="token">
                        <template v-if="goodsSkuDetail.sale_control?.view_price">
                            <span class="price ns-text-color">
                                {{ currentSalePrice }}<span class="price-unit" v-if="unitText">/{{ unitText }}</span>
                            </span>
    
                        </template>
                        <template v-else>
                            {{ goodsSkuDetail.sale_control?.not_buy_msg }}
                        </template>
                    </template>
                    <template v-else>
                        <span class="price ns-text-color" @click="$router.push('/login')">
                            登录可见
                        </span>
                    </template>
                </dd>
            </dl>
        </template>
        <template v-if="!showCouponPriceCard && showOriginalPrice">
            <dl  class="item-line">
                <dt  class="titl-name">原价</dt>
                <dd>
                    <template v-if="token">
                        <template v-if="goodsSkuDetail.sale_control?.view_price">
                        <i style="color: #303133 ; font-size: 14px;"><em>¥</em> {{ goodsSkuDetail.original_price }}</i>
                        </template>
                        <template v-else>
                            {{goodsSkuDetail.sale_control?.not_buy_msg}}
                        </template>
                    </template>
                    <template v-else>
                        <span style="color: #303133 ; font-size: 14px;"> <em>¥</em> {{ storeWithoutAuthority }}</span>
                    </template>
                </dd>
            </dl>
        </template>
        <template v-if="!showCouponPriceCard && showCouponPrice">
            <dl class="item-line">
                <dt class="titl-name" style="">惠后约</dt>
                <dd>
                    <template v-if="token">
                        <template v-if="goodsSkuDetail.sale_control?.view_price">
                            <span style="color: #303133 ; font-size: 14px;" ><em>¥</em>{{ goodsSkuDetail.coupon_price  }}</span>
                        </template>
                        <template v-else>
                            <span style="color: #303133 ; font-size: 14px;"><em>¥</em>{{ goodsSkuDetail.sale_control?.not_buy_msg }}</span>
                        </template>
                    </template>
                    <template v-else>
                        <span style="color: #303133 ; font-size: 14px;"> <em>¥</em>
                            {{ storeWithoutAuthority }}</span>
                    </template>
                </dd>
            </dl>
        </template>
        <template v-if="showMarketPrice">
            <dl class="item-line">
                <dt class="titl-name" style="">建议零售价</dt>
                <dd>
                    <template v-if="token">
                        <template v-if="goodsSkuDetail.sale_control?.view_price">
                            <span style="color: #303133 ; font-size: 14px;" ><em>¥</em>{{ goodsSkuDetail.market_price  }}</span>
                        </template>
                        <template v-else>
                            <span style="color: #303133 ; font-size: 14px;"><em>¥</em>{{ goodsSkuDetail.sale_control?.not_buy_msg }}</span>
                        </template>
                    </template>
                    <template v-else>
                        <span style="color: #303133 ; font-size: 14px;"> <em>¥</em>
                            {{ storeWithoutAuthority }}</span>
                    </template>
                </dd>
            </dl>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    props: {
        goodsSkuDetail: {
            type: Object,
            default: () => { }
        },
        token: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters(["storeWithoutAuthority"]),
        unitText() {
            return this.goodsSkuDetail.unit || ''
        },
        currentSalePrice() {
            return this.toNumber(this.goodsSkuDetail.discount_price) > 0 ? this.goodsSkuDetail.discount_price : this.goodsSkuDetail.price
        },
        canViewPrice() {
            return Boolean(this.goodsSkuDetail.sale_control && this.goodsSkuDetail.sale_control.view_price)
        },
        showCouponPrice() {
            let {coupon_price} =this.goodsSkuDetail;
            if(!coupon_price){
                return false
            }
            if(typeof this.goodsSkuDetail.coupon_price == 'string'){
                const couponPrice = this.toNumber(this.goodsSkuDetail.coupon_price)
                return couponPrice > 0 && couponPrice !== this.toNumber(this.currentSalePrice)
            }else{
                if(this.goodsSkuDetail.coupon_price.length > 1){
                    return true
                }
            }
        },
        showCouponPriceCard() {
            return Boolean(this.token && this.canViewPrice && this.showCouponPrice)
        },
        showOriginalPrice() {
            const originalPrice = this.toNumber(this.goodsSkuDetail.original_price)
            return originalPrice > 0 && originalPrice !== this.toNumber(this.currentSalePrice)
        },
        showMarketPrice() {
            const marketPrice = this.toNumber(this.goodsSkuDetail.market_price)
            return marketPrice > 0 && marketPrice !== this.toNumber(this.currentSalePrice)
        },
        savingText() {
            let {coupon_price} =this.goodsSkuDetail;
            if(!coupon_price){
                return ''
            }
            if(typeof coupon_price == 'string'){
                const salePrice = this.toNumber(this.currentSalePrice)
                const couponPrice = this.toNumber(coupon_price)
                if (salePrice <= 0 || couponPrice <= 0 || couponPrice >= salePrice) return ''
                return `约省 ${Math.round(((salePrice - couponPrice) / salePrice) * 100)}%`
            }else{
                if(coupon_price.length > 1){
                    const salePrice = this.toNumber(this.currentSalePrice)
                    const couponPrice_min = this.toNumber(coupon_price[0])
                    const couponPrice_max = this.toNumber(coupon_price[1])
                    return `约省 ${Math.round(((salePrice - couponPrice_min) / salePrice) * 100)}%~${Math.round(((salePrice - couponPrice_max) / salePrice) * 100)}%`
                }
            }
            
        }
    },
    methods: {
        toNumber(value) {
            const number = Number(value)
            return Number.isNaN(number) ? 0 : number
        }
    }
}
</script>

<style lang="scss" scoped>
.titl-name{
    width: 88px !important;
    min-width: 88px !important;
    box-sizing: border-box;
    padding-left: 0 !important;
    margin-right: 8px !important;
    text-align: left !important;
    text-align-last: left !important;
    letter-spacing: 1px !important;

    &::after {
        display: none !important;
    }
}

.benefit-price-card {
    box-sizing: border-box;
    width: 100%;
    min-height: 136px;
    padding: 12px;
    border: 1px solid rgba(50, 188, 111, 0.36);
    background: rgba(50, 188, 111, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.benefit-price-main {
    min-width: 0;
}

.benefit-price-head {
    display: flex;
    align-items: center;
    gap: 12px;
}

.benefit-price-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    padding: 0 8px;
    box-sizing: border-box;
    border: 1px solid #32BC6F;
    background: rgba(50, 188, 111, 0.08);
    color: #32BC6F;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
}

.benefit-price-desc {
    color: #555;
}

.benefit-price-row {
    display: flex;
    align-items: baseline;
    margin-top: 10px;
    color: #32BC6F;
}

.benefit-yuan {
    margin-right: 6px;
    font-size: 20px;
    line-height: 1;
    font-weight: 800;
    font-style: normal;
}

.benefit-price {
    font-size: 36px;
    line-height: 0.9;
    font-weight: 800;
    letter-spacing: 0;
}

.benefit-unit {
    margin-left: 4px;
    font-size: 20px;
    line-height: 1;
    font-weight: 700;
}

.benefit-origin-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #555;
}

.benefit-origin-price {
    text-decoration: line-through;
}

.benefit-save-tag {
    flex-shrink: 0;
    min-width: 86px;
    padding: 7px 14px;
    box-sizing: border-box;
    background: #32BC6F;
    color: #ffffff;
    text-align: center;
    font-size: 13px;
    line-height: 18px;
    font-weight: 800;
}
</style>
